import { CommonModule } from '@angular/common';
import { Injector, NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { Addin, AddinModule } from '@techwan/ionic-core';
import { DepartureTicketInfoCollapsibleService } from './services/executables/departure-ticket-info-collapsible/departure-ticket-info-collapsible.service';
import { DepartureTicketInfoCollapsibleViewComponent } from './views/departure-ticket-info-collapsible-view/departure-ticket-info-collapsible-view.component';

const views = [DepartureTicketInfoCollapsibleViewComponent];

const components = [...views];

const executables = [DepartureTicketInfoCollapsibleService];

const providers = [...executables];

@Addin({
  name: 'DepartureTicketInfo',
  require: ['singlecallcard']
})
@NgModule({
  declarations: [...components],
  providers,
  imports: [CommonModule, IonicModule, TranslateModule]
})
export class DepartureTicketInfoModule extends AddinModule {
  constructor(injector: Injector) {
    super(injector, views, executables);
  }
}
